import * as React from 'react';
import { useState } from 'react';
import { DsiNavigationDropdownItem as NavigationDropdownItem } from './NavigationDropdownItem';
import { NavigationDropdownItemWindow } from './NavigationDropdownItemWindow';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../..';
import {
  resolveCategoryName,
  resolveCategoryUrlString,
} from '../../../utilities/category';
import { IconType } from '../General/SvgIcon';

export interface Props {
  category: any;
  isOpenDropdown?: boolean;
  onClickDropdown?: any;
  level: number;
  icon?: IconType;
  byId?: any
}

function FirstNavigationItems({
  category,
  onClickDropdown,
  level,
  icon,
  byId
}: Props) {
  const [isOpenNext, setIsOpenNext] = useState<boolean>(false);
  const [isOpenNavWindow, setIsOpenNavWindow] = useState<boolean>(false);
  level++;

  const handleClickPlusNext = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (category) {
      if (category && category.children && category.children.length > 0) {
        setIsOpenNext(!isOpenNext);
      } else {
        setIsOpenNext(false);
      }
    }
  };

  const onMouseEnter = () => {
    if (category && category.children && category.children.length > 0) {
      setIsOpenNavWindow(true);
    } else {
      setIsOpenNavWindow(false);
    }
  };

  const onMouseLeave = () => {
    setIsOpenNavWindow(false);
  };

  return (
    <>
      <ItemWrapper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <NavigationDropdownItem
          onClick={onClickDropdown}
          onClickPlus={handleClickPlusNext}
          key={category.category_id}
          id={category.redirect_category_id || category.category_id}
          url={resolveCategoryUrlString(category, byId)}
          name={resolveCategoryName(category)}
          level={level}
          isOpen={isOpenNext}
          hasMore={category.children.length > 0}
          icon={icon}
        />
        {isOpenNavWindow && level === 0 && (
          <NavigationDropdownItemWindow
            category={category}
            onClick={onClickDropdown}
            byId={byId}
          />
        )}
      </ItemWrapper>
      {isOpenNext && category.children && level < 3 && (
        <OtherItemsWrapper>
          {category.children &&
            category.children.map(item => (
              <FirstNavigationItems
                key={item.category_id}
                category={item}
                level={level}
                onClickDropdown={onClickDropdown}
                byId={byId}
              />
            ))}
        </OtherItemsWrapper>
      )}
    </>
  );
}

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const OtherItemsWrapper = styled(FlexCol)`
  width: ${rem(290)};
  border-radius: 0 0 0 ${rem(2)};
  color: black;
  padding: 0;
  box-shadow: initial;
  overflow-y: auto;
`;

export { FirstNavigationItems as DsiFirstNavigationItems };
